export const PERFIS_UNIDADE_PAGINATION_SETTINGS_DEFAULT = {
  pageNumber: 0,
  pageSize: 20,
  sortDir: "ASC",
  sortField: "nome",
};
